import type Experiments from '@wix/wix-experiments'
import {
  EDITOR_TYPE,
  isBlocks,
  isClassicEditor,
  isStudio,
} from './infra/editorType'
import { match } from 'ts-pattern'

export type Features = Awaited<ReturnType<typeof getFeatures>>

export const getFeatures = async ({
  experimentsManager,
  editorType,
}: {
  editorType: EDITOR_TYPE
  experimentsManager: Experiments
}) => {
  return {
    get pagesManifest() {
      return isClassicEditor(editorType) || isStudio(editorType)
    },
    get inspectorXP() {
      return match(editorType)
        .when(isStudio, () => true)
        .when(isClassicEditor, () =>
          experimentsManager.enabled(
            'specs.wixDataClient.NewClassicBindingExperience',
          ),
        )
        .when(isBlocks, () => true)
        .otherwise(() => false)
    },
    get propsBinding() {
      return (
        editorType === EDITOR_TYPE.BLOCKS &&
        experimentsManager.enabled('specs.wixDataClient.BlocksPropsBinding')
      )
    },
    get editor3orStudio2() {
      return (
        editorType === EDITOR_TYPE.EDITOR3 || editorType === EDITOR_TYPE.STUDIO2
      )
    },
    get onlyLocalBindingDefinitions() {
      return experimentsManager.enabled('specs.wixDataClient.noEERegistry')
    },
  }
}
